import { ColumnStyleWidth } from '../enums';

// Should take into consideration that width does not include padding, border, or margin.
export class ColumnStyleClass {
  public static readonly textColumn = {
    style: {
      width: ColumnStyleWidth.TEXT_COLUMN,
    },
    class: ['c-text-column'],
  };

  public static readonly doubleWidthTextColumn = {
    style: {
      width: ColumnStyleWidth.DOUBLE_WIDTH_TEXT_COLUMN,
    },
    class: ['c-double-width-text-column'],
  };

  public static readonly numberColumn = {
    style: {
      width: ColumnStyleWidth.NUMBER_COLUMN,
    },
    class: ['c-number-column'],
  };

  public static readonly priceColumn = {
    style: {
      width: ColumnStyleWidth.PRICE_COLUMN,
    },
    class: ['c-price-column'],
  };

  public static readonly fixedContentColumn = {
    style: {
      width: ColumnStyleWidth.FIXED_CONTENT_COLUMN,
    },
    class: ['c-fixed-content-column'],
  };

  public static readonly imageColumn = {
    style: {
      width: ColumnStyleWidth.IMAGE_COLUMN,
      'min-width': ColumnStyleWidth.IMAGE_COLUMN,
    },
    class: ['c-image-column'],
  };

  public static readonly iconColumn = {
    style: { width: ColumnStyleWidth.ICON_COLUMN, 'min-width': ColumnStyleWidth.ICON_COLUMN },
    class: ['c-icon-column'],
  };

  public static readonly statusColumn = {
    style: {
      width: ColumnStyleWidth.STATUS_COLUMN,
      'max-width': ColumnStyleWidth.STATUS_COLUMN,
    },
    class: ['c-status-column'],
  };

  public static readonly menuStatusColumn = {
    style: {
      width: ColumnStyleWidth.MENU_STATUS_COLUMN,
      'max-width': ColumnStyleWidth.MENU_STATUS_COLUMN,
    },
    class: ['c-menu-status-column'],
  };

  public static readonly barcodeColumn = {
    style: {
      width: ColumnStyleWidth.BARCODE_COLUMN,
      'max-width': ColumnStyleWidth.BARCODE_COLUMN,
    },
    class: ['c-text-column'],
  };
}
